import { jsx as _jsx } from "react/jsx-runtime";
import { Box, FormControlLabel, RadioGroup, Radio, } from '@mui/material';
const SingleChoiceAnswer = ({ availableAnswers, response, setResponse, disabled, }) => {
    const updateAnswer = (ev) => {
        setResponse(ev.target.value);
    };
    return (_jsx(Box, { sx: { ml: 4 }, children: _jsx(RadioGroup, { "aria-labelledby": "demo-radio-buttons-group-label", value: response, name: "radio-buttons-group", sx: {
                display: 'block',
            }, onChange: (ev) => updateAnswer(ev), children: availableAnswers.map((answer) => (_jsx(FormControlLabel, { value: answer.id, sx: {
                    width: '80%',
                    mt: 1,
                }, control: (_jsx(Radio, { sx: {
                        color: '#007bad',
                        '&$checked': {
                            color: '#007bad',
                        },
                        '&$disabled': {
                            color: '#007bad',
                        },
                    }, value: answer.id, disabled: disabled })), label: answer.answerText }, answer.id))) }) }));
};
export default SingleChoiceAnswer;
//# sourceMappingURL=SingleChoiceAnswer.js.map